module.exports = __webpack_public_path__ + "public/StoreIcon/plusIcon.svg?0f4c60ef";